import activityType from './activityType'
export default activityType
